import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-auth-parent',
    templateUrl: './auth-parent.component.html',
    styleUrls: ['./auth-parent.component.scss'],
    standalone: false
})
export class AuthParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
